<template>
  <div>
    <!-- 内容 -->
    <vxe-table
      :id="'myTable' + Math.random()"
      border
      :height="height"
      :max-height="maxHeight"
      :show-overflow="false"
      :row-config="{ isHover: true, isCurrent: true }"
      :scroll-y="{ enabled: false }"
      :show-footer="totalKeyList.length > 0"
      :data="list"
      size="mini"
      :footer-method="footerMethod"
      :footer-row-style="{ background: '#F1F1F1' }"
      :checkbox-config="{ highlight: true }"
      @checkbox-change="selectChangeEvent"
      @checkbox-all="selectAllCheckboxChange"
      @cell-dblclick="cellDblclick"
      :custom-config="{ storage: true }"
      :column-config="{ isCurrent: false, isHover: false, resizable: true }"
      @resizable-change="resizableChange"
      @sort-change="sortChangeEvent"
      :span-method="mergeRowMethod"
      :row-style="customRowEval"
      @scroll="rollScroll"
      ref="xTable"
    >
      <vxe-column
        v-if="columnType == 'columnBox' || columnType == 'columnAll'"
        :field="checkKey"
        :fixed="fixedAll ? 'left' : ''"
        type="checkbox"
        width="40"
        align="center"
      ></vxe-column>
      <vxe-column
        v-if="columnType == 'columnIndex' || columnType == 'columnAll'"
        :field="checkKey"
        :fixed="fixedAll ? 'left' : ''"
        width="50"
        type="seq"
        title="序号"
        align="center"
      ></vxe-column>
      <vxe-column
        align="center"
        v-for="(item, index) in getList(titleList)"
        :key="index + Math.random()"
        :field="item.key ? item.key : item.value"
        :title="item.name"
        :width="item.width ? item.width : undefined"
        :fixed="item.fixedState == true ? 'left' : ''"
      >
        <template slot-scope="scope">
          <!-- 显示所有数据 -->
          <div :style="textAlignGet(item)">
            <div
              style="
                min-width: 20px;
                min-height: 20px;
                display: inline-block;
                max-height: 230px;
                overflow: auto;
              "
              @click="cellClickEvent(scope.row, scope.$rowIndex, scope.column)"
            >
              <!-- 文本显示 -->
              <span
                :style="item.color ? 'color:' + item.color : ''"
                v-if="item.dataType == 'text'"
              >
                {{ scope.row[item.value] }}
              </span>
              <!-- 处理时间 -->
              <span
                :style="item.color ? 'color:' + item.color : ''"
                v-else-if="item.dataType == 'dateTime'"
                >{{ formatDate(scope.row[item.value]) }}</span
              >
              <!-- 富文本显示 -->
              <span v-else-if="item.dataType == 'richText'">
                <el-button
                  size="mini"
                  type="primary"
                  @click="richTextOpen(scope.row, item, 1)"
                  >查看</el-button
                >
              </span>
              <!-- 文件显示 -->
              <div v-else-if="item.dataType == 'fileList'">
                <el-button
                  size="mini"
                  type="primary"
                  @click="updateFileList(scope.row, scope.row[item.value], item)"
                >
                  {{ getFileList(scope.row[item.value]) }}
                </el-button>
              </div>
              <!-- 显示数据 -->
              <span
                :style="item.color ? 'color:' + item.color : ''"
                v-else-if="item.dataType == 'textarea'"
                v-html="textareaShow(scope.row[item.value])"
              ></span>
              <!-- excel -->
              <div v-else-if="item.dataType == 'excel'">
                <el-button
                  v-if="
                    scope.row[item.value] != null &&
                    scope.row[item.value] != undefined &&
                    scope.row[item.value] != '' &&
                    scope.row[item.value] != 0
                  "
                  @click="excelOpen(scope.row, item)"
                  size="mini"
                  type="primary"
                  >打开</el-button
                >
                <el-button
                  v-else
                  @click="excelSuccess(scope.row, item)"
                  size="mini"
                  type="primary"
                  >打开</el-button
                >
              </div>
              <!-- 多规格显示数据 -->
              <div v-else-if="item.dataType == 'textList'">
                <el-descriptions
                  v-if="
                    !scope.row.baseMaterialSpecDisplayTemplate ||
                    scope.row.baseMaterialSpecDisplayTemplate == null ||
                    scope.row.baseMaterialSpecDisplayTemplate == ''
                  "
                  direction="horizontal"
                  size="mini"
                  :column="1"
                >
                  <el-descriptions-item
                    v-for="(specItem, specIndex) in scope.row[item.value]"
                    :key="specIndex"
                  >
                    <template slot="label">
                      {{ specItem.specKey }}
                    </template>
                    <span
                      v-if="specItem.specFunc == ''"
                      v-html="htmlDataShow(specItem.specValue)"
                    ></span>
                    <span v-if="specItem.specFunc != ''">{{ specItem.specValue }}</span>
                  </el-descriptions-item>
                </el-descriptions>
                <!-- :style="item.align != null&&item.align != '' ? textAlignGet(item) : 'text-align: left'" -->
                <div
                  v-else
                  :style="'text-align: left'"
                  v-html="
                    specsShowHtml(
                      scope.row.baseMaterialSpecDisplayTemplate,
                      scope.row[item.value]
                    )
                  "
                ></div>
              </div>
              <!-- 图片显示 -->
              <el-image
                v-else-if="item.dataType == 'image'"
                :style="'width: 90%;max-height:' + imgWidth(item) + 'px'"
                :src="imageListShow(scope.row[item.value])"
                :preview-src-list="imageListAllShow(scope.row[item.value])"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
              <!-- 处理下拉框数据显示 -->
              <span v-else-if="item.dataType == 'select'">{{
                selectDataShow(scope.row[item.value], item)
              }}</span>
              <span
                v-else-if="item.dataType == 'customSelect'"
                :style="customSelectCssShow(scope.row[item.value], item.selectOptionList)"
                >{{
                  customSelectDataShow(scope.row[item.value], item.selectOptionList)
                }}</span
              >
              <!-- 显示数据 -->
              <span :style="item.color ? 'color:' + item.color : ''" v-else>
                {{ scope.row[item.value] }}
              </span>
            </div>
          </div>
        </template>
      </vxe-column>
      <vxe-column
        v-if="btnListState()"
        :fixed="fixedAll ? 'right' : ''"
        title="操作"
        :width="operationWidth"
        :field="checkKey"
        align="center"
      >
        <template slot-scope="scope">
          <el-popover
            placement="bottom"
            width="220"
            trigger="click"
            v-if="
              (state === 0 || stateShow.index != scope.seq) && tableBtnList.length > 1
            "
          >
            <div
              v-for="(item, index) in tableBtnList"
              :key="index"
              @click="btnClick(scope.row, item, scope.seq)"
              class="spanBtn"
            >
              <span v-if="item.name">
                <span v-if="item.perm && checkPermCodeExist(item.perm)">{{
                  item.name
                }}</span>
                <span v-else>{{ item.name }}</span>
              </span>
              <span v-if="!item.name">{{ item }}</span>
            </div>
            <div style="clear: both"></div>
            <el-button
              style="color: #1476c3; border-color: #1476c3"
              slot="reference"
              size="small"
              @click="trendsBtn(scope.row)"
              >操作</el-button
            >
          </el-popover>
          <el-button
            size="small"
            v-if="
              (state === 0 || stateShow.index != scope.seq) && tableBtnList.length == 1
            "
            @click="btnClick(scope.row, tableBtnList[0], scope.seq)"
            style="color: #1476c3; border-color: #1476c3"
            >{{ tableBtnList[0] }}</el-button
          >
          <el-button
            size="small"
            v-if="state !== 0 && stateShow.index == scope.seq"
            @click="btnClick(scope.row, '保存', scope.seq)"
            style="color: #1476c3; border-color: #1476c3"
            >保存</el-button
          >
        </template>
      </vxe-column>
    </vxe-table>
    <!-- 文件上传 -->
    <el-dialog
      :visible.sync="dialogState.show1"
      append-to-body
      :close-on-click-modal="false"
      class="dialog"
      :title="dialogTitle"
      width="50%"
      @close="dialogClose"
    >
      <myUploadTable
        :list="tableList"
        :type="dialogType"
        :status="dialogStatus"
        :markIndex="markIndex"
        @uploadSuccess="uploadSuccess"
        @uploadDelete="uploadDelete"
      >
      </myUploadTable>
    </el-dialog>
    <!-- 富文本框 -->
    <el-dialog
      :visible.sync="dialogState.show2"
      :close-on-click-modal="false"
      append-to-body
      class="dialog"
      :title="dialogTitle"
      width="50%"
      @close="dialogClose"
    >
      <div v-if="richTextType === 0">
        <editor ref="myEditor" v-model="singleRowData[fileKey]"></editor>
        <div style="text-align: center; margin: 20px">
          <el-button size="small" type="primary" @click="richTextSave()">确定</el-button>
        </div>
      </div>
      <div class="htmlDiv" v-else v-html="singleRowData[fileKey]"></div>
    </el-dialog>
  </div>
</template>
<script>
// 导入draggable组件
// import { getToken } from "@/utils/auth";
// import { listUser } from "@/api/system/user";
// import { getDicts } from "@/api/system/dict/data";
import { accAdd, readDictionarySelect, _debounce, readUserSelect } from "@/utils/myUtils";
import { SystemController } from "@/api";
import projectConfig from "@/core/config";
import { getToken } from "@/utils";
export default {
  props: {
    // 操作栏宽度
    operationWidth: {
      type: Number,
      default: 80,
    },
    // 上传模块
    uplaodModel: {
      type: Object,
      default: "文件",
    },
    // 是否定位
    fixedAll: {
      type: Boolean,
      default: true,
    },
    // 单行判断条件，显示不同颜色
    rowStyle: {
      type: Object,
      default: "",
    },
    // table 序号和多选绑定的key，方便合并单元格使用
    checkKey: {
      type: String,
      default: "",
    },
    // table 合并单元格的key集合
    keyData: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    // 树状图数据
    treeList: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    // 计算总数传Key集合
    totalKeyList: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    // table是否显示多行
    overflow: {
      type: Boolean,
      default: false,
    },
    // table行高
    height: {
      type: Number,
      required: false,
      default: undefined,
    },
    // table最大行高
    maxHeight: {
      type: Number,
      required: false,
      default: undefined,
    },
    // table显示的数据集合
    list: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    // table显示的行内按钮
    tableBtnList: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    // myHtml专用
    operationTitleData: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    // myHtml专用
    titleOperationTitleData: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    // table显示的标头集合
    titleList: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    // table 序号或多选 columnIndex序号,columnBox复选框
    columnType: {
      type: String,
      default: "",
    },
    // 多选key
    customKey: {
      type: String,
      default: "id",
    },
    // 多选Name
    customName: {
      type: String,
      default: "name",
    },
    // 下拉框显示数据
    selectList: {
      type: Object,
      default: () => ({}),
    },
    // table行内选择自定义table的数据集合
    customList: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    // table行内选择自定义table的表头数据集合
    customTitleList: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    // table行内选择自定义table的分页数据
    customListQuery: {
      type: Object,
      default: () => ({
        total: 0,
        pageNum: 1,
        pageSize: 10,
      }),
    },
    // 上传组件状态
    dialogStatus: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  components: {},
  data() {
    return {
      userInitQuery: _debounce(function (val, value) {
        this.userListQuery.pageNum = val;
        SystemController.getUserList(this, {
          sysUserDtoFilter: { searchString: value },
          pageParam: this.userListQuery,
        }).then((res) => {
          if (res.data.totalCount > 0) {
            this.userList = res.data.dataList;
            this.userListQuery.total = res.data.totalCount;
          } else {
            this.userList = [];
          }
          this.userLoading = false;
        });
      }, 300),
      operationState: false,
      titleData: {},
      stateShow: {
        index: 0, // 索引
        show: false, // 是否编辑
      },
      state: 0, // 1.新增 2.编辑
      url: projectConfig.imageBaseUrl, // 显示图片路径 //后台路径
      imageUrl: projectConfig.baseUrl + "qingguang/tenantbussiness/common/upload", // 上传图片路径

      headers: { Authorization: getToken() }, // { Authorization: "Bearer " + getToken() },
      userList: [], // 员工表选择
      userListQuery: {
        userName: "",
        total: 0,
        pageNum: 1,
        pageSize: 100,
      },
      flag: false,
      customLoading: true,
      customSearch: "",
      userLoading: true,
      pagingList: [],
      userAllList: [],
      popoverStatus: false,
      // ----------------
      dialogState: {
        show1: false,
        show2: false,
        show3: false,
        show4: false,
      },
      singleRowData: {},
      tableList: [],
      dialogType: 1,
      dialogTitle: "",
      markIndex: 1,
      fileKey: null,
      // -------------------
      colors: [
        { color: "#f56c6c", percentage: 20 },
        { color: "#e6a23c", percentage: 40 },
        { color: "#5cb87a", percentage: 60 },
        { color: "#1989fa", percentage: 80 },
        { color: "#6f7ad3", percentage: 100 },
      ],
      richTextType: 0, // 富文本0.修改，1.查看
    };
  },
  created() {},
  mounted() {},
  methods: {
    // 文本对齐方式
    textAlignGet(item) {
      if (item.align) {
        return "text-align:" + item.align;
      }
    },
    // 计算图片高度
    imgWidth(item) {
      let width;
      if (item.width) {
        width = parseFloat(item.width) * 1.5;
      }
      return width;
    },
    // 打开富文本
    richTextOpen(row, item, type) {
      if (!row[item.value]) {
        row[item.value] = " ";
      }
      this.singleRowData = row;
      this.dialogTitle = item.name;
      this.fileKey = item.value;
      this.richTextType = type;
      this.dialogState.show2 = true;
      this.$nextTick(() => {
        this.$refs.myEditor.initTinymce();
      });
    },
    richTextSave() {
      this.$emit("richTextSave", this.singleRowData);
      this.dialogState.show2 = false;
    },
    // 滚动条
    rollScroll() {
      // 1.记录滚动条位置
      let { scrollTop } = this.$refs.xTable.getScroll();
      let scrollHeight = scrollTop;
      document.body.click();
      this.$emit("rollScroll", scrollHeight);
    },
    reductionScroll(scrollHeight) {
      scrollHeight = parseInt(scrollHeight);
      setTimeout(() => {
        // 4.还原滚动条位置:定位到勾选行
        this.$nextTick(() => {
          this.$refs.xTable.scrollTo(0, scrollHeight);
        });
      }, 50);
    },
    // 处理数量精度
    numberAccuracyGet(data, row) {
      let num = 0;
      if (data) {
        try {
          num = parseFloat(data);
          num = num.toFixed(this.$root.numberAccuracy);
        } catch (error) {
          num = data;
        }
      }
      return num;
    },
    // 处理价格精度
    priceAccuracyGet(data, row) {
      let num = 0;
      if (data) {
        try {
          num = parseFloat(data);
          num = num.toFixed(this.$root.accuracy);
        } catch (error) {
          num = data;
        }
      }
      return num;
    },
    // 处理文件附件
    getFileList(list) {
      let count = 0;
      try {
        count = JSON.parse(list).length;
      } catch (error) {
        count = 0;
      }
      return count;
    },
    updateFileList(row, list, item) {
      this.singleRowData = row;
      this.dialogType = 2;
      this.dialogTitle = item.name;
      this.fileKey = item.value;
      try {
        this.tableList = JSON.parse(list);
      } catch (error) {
        this.tableList = [];
      }
      this.dialogState.show1 = true;
    },
    uploadSuccess(list, type, markIndex) {
      this.singleRowData[this.fileKey] = JSON.stringify(list);
      this.tableList = list;
      this.$emit("uploadSuccess", this.singleRowData, this.fileKey);
    },
    uploadDelete(list, type, markIndex) {
      this.singleRowData[this.fileKey] = JSON.stringify(list);
      this.tableList = list;
      this.$emit("uploadDelete", this.singleRowData, this.fileKey);
    },
    dialogClose() {
      this.dialogState.show1 = false;
      this.$emit("dialogClose");
    },
    // 规格显示
    specsShowHtml(text, list) {
      try {
        list.forEach((item) => {
          if (item.specFunc == null || item.specFunc == "" || !item.specFunc) {
            let name = "{#" + item.specKey + "}";
            text = text.replaceAll(name, item.specValue);
          } else {
            // 查询公式需要的数据字段
            let func = item.specFunc;
            list.forEach((element) => {
              let name = "{#" + element.specKey + "}";
              if (func.indexOf(name) > -1) {
                func = func.replaceAll(name, element.specValue);
              }
            });
            item.specValue = eval(func);
            let name2 = "{#" + item.specKey + "}";
            text = text.replaceAll(name2, item.specValue);
          }
        });
        text = text.replace(/\{#.*?\}/g, "");
        return text;
      } catch (error) {
        return list;
      }
    },
    // excel
    excelOpen(row, item) {
      this.$emit("excelOpen", row, item);
    },
    // 上传成功
    excelSuccess(row, item) {
      this.$emit("excelSuccess", row, item);
    },
    // 列表页按钮集合显示
    trendsBtn(row) {
      this.$emit("trendsBtn", row);
    },
    getUserList() {
      SystemController.getUserList(this, {}).then((res) => {
        this.userAllList = res.data.dataList;
      });
    },
    // 多选显示
    selectListShow(row, valueKey) {
      try {
        // 多选下拉框显示
        let nameList = "";
        row.forEach((item, index) => {
          let single = this.selectList[valueKey].list.filter(
            (a) => a[this.selectList[valueKey].key] === item
          );
          if (row.length === index + 1) {
            if (single.length > 0) {
              nameList += single[0][this.selectList[valueKey].name];
            }
          } else {
            if (single.length > 0) {
              nameList += single[0][this.selectList[valueKey].name] + "，";
            }
          }
        });
        return nameList;
      } catch (error) {
        return row;
      }
    },
    // 用户多人显示
    userListShow(row) {
      try {
        // 员工ID集合
        let nameList = "";
        row.forEach((item) => {
          nameList += readUserSelect(item) + ",";
        });
        return nameList;
      } catch (error) {
        return row;
      }
    },
    // 处理三元算法判断字体颜色
    customRowEval({ row, column, rowIndex, columnIndex }) {
      try {
        return "";
      } catch (error) {
        return "";
      }
    },
    // 处理文本框
    textareaShow(val) {
      try {
        let text = val.replace(/\n|\r\n/g, "<br>");
        return text;
      } catch (error) {
        return val;
      }
    },
    // 高亮显示
    showCssDate(val) {
      if (val) {
        val += "";
      }
      if (
        val &&
        this.customSearch !== null &&
        this.customSearch !== "" &&
        val.indexOf(this.customSearch) !== -1
      ) {
        return val.replace(
          this.customSearch,
          '<font color="#f00">' + this.customSearch + "</font>"
        );
      } else {
        return val;
      }
    },
    // 排序
    sortChangeEvent({ field, order }) {
      let json = {
        asc: order == "asc",
        fieldName: field,
      };
      this.$emit("sortChangeEvent", json);
    },
    // 计算规格公式
    async inputSpecsValue(list) {
      try {
        for (let i = 0; i < list.length; i++) {
          let item = list[i];
          if (item.specFunc && item.specFunc != "" && item.specFunc != null) {
            let func = item.specFunc;
            // 查询公式需要的数据字段
            await list.forEach((element) => {
              let name = "{#" + element.specKey + "}";
              if (func.indexOf(name) > -1) {
                func = func.replace(name, element.specValue);
              }
            });
            item.specValue = eval(func);
            this.$set(list, i, item);
          }
        }
      } catch (error) {}
    },

    // 日期格式化
    formatDate(time) {
      try {
        if (time) {
          return this.$moment(time).format("YYYY-MM-DD");
        } else {
          return "暂无日期";
        }
      } catch (error) {
        return "暂无日期";
      }
    },
    // 处理多行文本
    htmlDataShow(data) {
      try {
        let text = data.replace(/\n|\r\n/g, "<br>");
        return text;
      } catch (error) {
        return "";
      }
    },
    // 新增多图片
    imageListHandleAvatarSuccess(row, res, file) {
      this.$emit("imageListHandleAvatarSuccess", row, res, file);
    },
    imageListHandleRemove(row, res, file) {
      let list = [];
      try {
        file.forEach((item) => {
          if (item.response) {
            list.push({
              name: item.name,
              url: item.response.data.uploadPath + item.response.data.filename,
            });
          } else {
            list.push({
              name: item.name,
              url: item.url.replace(this.url, ""),
            });
          }
        });
      } catch (error) {}

      this.$emit("imageListHandleRemove", row, list, res, file);
    },
    // 多图片处理数据
    imageListAllShow(list) {
      let text = [];
      try {
        JSON.parse(list).forEach((item) => {
          text.push(this.url + item.url);
        });
      } catch (error) {}
      return text;
    },
    // 多图片处理数据
    imageListShow(list) {
      let text = "";
      try {
        text = this.url + JSON.parse(list)[0].url;
      } catch (error) {}
      return text;
    },
    // 多规格数据处理显示
    textListShow(list) {
      let text = "";
      try {
        for (let i = 0; i < list.length; i++) {
          let kong = i == list.length - 1 ? "" : "/";
          text += list[i].specKey + ":" + list[i].specValue + kong;
        }
      } catch (error) {}
      return text;
    },
    // 点击树状图事件
    treeClick(row, cloumn) {
      this.$emit("treeClick", row, cloumn);
    },
    // 树节点返回数据
    treeRowClick(data, node, row) {
      document.body.click();
      this.$emit("treeRowClick", data, node, row);
    },
    customLoadingStatus() {
      this.customLoading = false;
    },
    // 选中自定义表单单行
    rowCustomClick(val, row, index, column) {
      document.body.click();
      this.$emit("rowCustomClick", val, row, index, column);
    },
    // 查询表单数据
    customClick(val, value, row, column) {
      this.customSearch = value;
      this.customLoading = true;
      this.customListQuery.pageNum = val;
      this.$emit("customClick", this.customListQuery, value, row, column);
    },
    // 表单分页
    customGetList(val, value, row, column) {
      this.customListQuery.pageNum = val;
      this.customClick(val, value, row, column);
    },
    // 查询员工
    userGetList(val, value) {
      this.userLoading = true;
      this.userInitQuery(val, value);
    },
    // 单击选中员工
    rowClick(val, row, column) {
      this.$emit("userRowClick", val, row, column);
      document.body.click();
    },
    // 编辑数字框返回数据，方便动态计算
    inputNumberClick(row, val) {
      this.$emit("inputNumberClick", row, val);
    },
    // 列宽改变
    resizableChange({ $rowIndex, column, columnIndex, $columnIndex, $event }) {
      this.$emit("resizableChange", column);
    },
    // 判断是否有操作栏显示
    btnListState() {
      if (this.tableBtnList && this.tableBtnList.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    // 编辑本行
    updateDataRow(index) {
      this.state = 2;
      this.stateShow = {
        index: index,
        show: true,
      };
    },
    // 恢复默认
    defaultDataRow() {
      this.state = 0;
      this.stateShow = {
        index: 0,
        show: false,
      };
    },
    // 按钮点击事件
    btnClick(row, item, index) {
      let btnName = "";
      if (item.name) {
        btnName = item.name;
      } else {
        btnName = item;
      }
      this.$emit("btnClick", row, btnName, index, this.state);
    },
    // 图片上传
    handleAvatarSuccess(val, key, res, file) {
      val[key] = res.data.uploadPath + res.data.filename;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 20;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 20MB!");
      }
      return isJPG && isLt2M;
    },
    // 单击事件
    cellClickEvent(row, $rowIndex, column) {
      switch (this.state) {
        case 0:
          this.$emit("cellClickEvent", row, column);
          break;
        case 1:
          if ($rowIndex + 1 != this.stateShow.index) {
            let data = this.list[0];
            this.$emit("frontDataClick", data, this.state);
          }
          break;
        case 2:
          if ($rowIndex + 1 != this.stateShow.index) {
            let data = this.list[this.stateShow.index - 1];
            this.$emit("frontDataClick", data, this.state);
          }
          break;
        default:
          break;
      }
    },
    // 双击编辑事件
    cellDblclick({
      row,
      rowIndex,
      $rowIndex,
      column,
      columnIndex,
      $columnIndex,
      $event,
    }) {
      switch (this.state) {
        case 1:
          if ($rowIndex + 1 != this.stateShow.index) {
            let data = this.list[0];
            this.$emit("frontDataClick", data, this.state);
          }
          break;
        case 2:
          if ($rowIndex + 1 != this.stateShow.index) {
            let data = this.list[this.stateShow.index - 1];
            this.$emit("frontDataClick", data, this.state);
          }
          break;
        default:
          break;
      }
      // 返回双击选中的数据
      this.$emit("cellDblclick", row, $rowIndex + 1);
    },
    // 新增数据
    insertOne(val) {
      if (this.state == 1 && this.stateShow.show == true) {
        this.$message.warning("有正在编辑的数据！");
        return;
      }
      this.list.unshift(val);
      this.stateShow = {
        index: 1,
        show: true,
      };
      this.state = 1;
    },
    customSelectDataShow(val, list) {
      if (list) {
        let single = list.filter((item) => {
          return item.value == val;
        });
        return single.length > 0 ? single[0].label : "";
      }
    },
    customSelectCssShow(val, list) {
      if (list) {
        let single = list.filter((item) => {
          return item.value == val;
        });
        let css = "padding:3px 8px;border-radius: 5px;";
        if (single.length > 0) {
          if (single[0].color) {
            css += "color:" + single[0].color + ";";
          }
          if (single[0].fontSize) {
            css += "font-size:" + single[0].fontSize + "px;";
          }
          if (single[0].backGroundColor) {
            css += "background-color:" + single[0].backGroundColor + ";";
          }
        }
        return css;
      }
    },
    // 下拉框数据显示
    selectDataListShow(item) {
      let dictionaryList = readDictionarySelect(item.selectOptionKey);
      return dictionaryList;
    },
    // 处理下拉框数据
    selectDataShow(val, item) {
      //   return this.selectDictLabel(list, val);
      let dictionaryList = readDictionarySelect(item.selectOptionKey);
      if (dictionaryList) {
        let single = dictionaryList.filter((item) => {
          return item.itemId == val;
        });
        return single.length > 0 ? single[0].name : val;
      }
    },
    // 处理数据
    getList(val) {
      try {
        let list = val.filter((item) => {
          if (item.userList && item.userList.length > 0) {
            if (item.userList.some((obj) => obj.userId == this.getUserInfo.userId)) {
              return item.isShow == true;
            }
          } else {
            return item.isShow == true;
          }
        });
        return list;
      } catch (error) {}
    },
    // 勾选复选框
    selectChangeEvent(val) {
      this.$emit("selectChangeEvent", val);
    },
    // 全选勾选事件
    selectAllCheckboxChange(val) {
      this.$emit("selectAllCheckboxChange", val);
    },

    // 合并表格
    footerMethod({ columns, data }) {
      let list = columns.map((column, _columnIndex) => {
        if (_columnIndex === 0) {
          return "合计";
        }
        if (this.totalKeyList.includes(column.field)) {
          return this.sumNum(data, column.field);
        } else {
          return "——";
        }
      });
      let json = [];
      json.push(list);
      return json;
    },
    // 计算总值
    sumNum(list, field) {
      let count = 0;
      list.forEach((item) => {
        count = accAdd(count, Number(item[field]));
      });
      return count;
    },
    // 合并单元格
    mergeRowMethod({ row, _rowIndex, column, visibleData }) {
      let keyData = [];
      if (this.keyData) {
        keyData = this.keyData;
      }
      const fields = keyData;
      const cellValue = row[column.field];
      if (cellValue && fields.includes(column.field)) {
        const prevRow = visibleData[_rowIndex - 1];
        let nextRow = visibleData[_rowIndex + 1];
        if (prevRow && prevRow[column.field] === cellValue) {
          return { rowspan: 0, colspan: 0 };
        } else {
          let countRowspan = 1;
          while (nextRow && nextRow[column.field] === cellValue) {
            nextRow = visibleData[++countRowspan + _rowIndex];
          }
          if (countRowspan > 1) {
            return { rowspan: countRowspan, colspan: 1 };
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-textarea__inner {
  height: 36px;
}
.item_image {
  height: 50px;
  padding: 0px 1px;
}
.section {
  text-align: left;
  width: 100%;
}
.section ::v-deep .el-upload--picture-card {
  padding-top: 3px;
}
.section ::v-deep .el-upload-list__item-preview {
  display: none !important;
}
.section ::v-deep .el-upload-list--picture-card .el-upload-list__item-actions {
  font-size: 14px;
}
.section ::v-deep .el-upload-list--picture-card .el-upload-list__item {
  width: 38px;
  height: 38px;
}
.section ::v-deep .el-upload--picture-card {
  width: 38px;
  height: 38px;
  line-height: 38px;
  vertical-align: middle;
}
.btnOne {
  background: #1476c3;
  color: white;
  margin-right: 20px;
}
.spanBtn {
  color: #1476c3;
  font-size: 14px;
  cursor: pointer;
  width: 96px;
  text-align: center;
  line-height: 30px;
  float: left;
}

/*选中样式*/
.chosen {
  border: solid 1px #3089dc !important;
}

.avatar {
  height: 50px;
}
.operationItem {
  float: left;
  margin: 0px 5px 0px 5px;
  padding-bottom: 10px;
}
.titleSpan {
  font-size: 14px;
  font-weight: 600;
  margin-right: 10px;
}
.operation {
  margin-bottom: 20px;
  padding-top: 10px;
}
/* 那啥，没用的，删了出问题不负责 */
.section {
  height: 50px;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -moz-user-select: none; /* Firefox私有属性 */
  -webkit-user-select: none; /* WebKit内核私有属性 */
  -ms-user-select: none; /* IE私有属性(IE10及以后) */
  -khtml-user-select: none; /* KHTML内核私有属性 */
  -o-user-select: none; /* Opera私有属性 */
  user-select: none; /* CSS3属性 */
}
.itemFixed-nav {
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}
.itemFixed-nav-content {
  display: flex;
}

::v-deep .vxe-table--render-default .vxe-cell {
  padding: 0px;
}
</style>
